module.exports = __webpack_public_path__ + "static/media/31e0c094-e345-4a54-a797-d5f1a5885572.6a50b2f7.woff";